(() => {
  const root = document.body.dataset.root.replace(/\/?$/, '/');
  const dialog = document.querySelector('#cart-dialog');
  const items = document.querySelector('#cart-items');
  const footer = document.querySelector('.cart-footer');
  const cartError = document.querySelector('#cart-error');
  const confidence = document.querySelector('#cart-confidence');
  const reassurance = document.querySelector('#cart-reassurance');
  const discount = document.querySelector('#cart-discount');
  const productError = document.querySelector('#product-error');
  const productForm = document.querySelector('#mentik-product-form');
  const addButton = document.querySelector('#add-cart');
  const options = document.querySelector('#bundle-options');
  const boxComposer = document.querySelector('#box-composer');
  const boxChoices = document.querySelector('#box-flavor-choices');
  let configuredFlavors = [];
  const cartSession = document.querySelector('#cart-session');
  const sessionKey = `mentik-checkout-chrono:${root}`;
  let variantData = {};
  try { variantData = JSON.parse(document.querySelector('#cart-variant-data')?.textContent || '{}'); } catch {}
  const catalog = Object.entries(variantData).map(([id, variant]) => ({ id, ...variant }));
  const availableFlavors = [...new Set(catalog.map(variant => variant.flavor).filter(flavor => flavor && flavor !== 'Mix au choix'))];
  let sessionDeadline = 0;
  let sessionInterval = null;
  let sessionOpening = false;
  let currency = document.body.dataset.currency || 'EUR';
  let currentCart = null;
  let busy = false;
  let closing = false;
  let scrollPosition = 0;
  const money = amount => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(amount / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
  function describeFlavors(boxFlavors) {
    const counts = new Map();
    boxFlavors.forEach(flavor => counts.set(flavor, (counts.get(flavor) || 0) + 1));
    return [...counts].map(([flavor, count]) => `${count} × ${flavor}`).join(' · ');
  }
  function cartItemDetails(item) {
    const metadata = variantData[item.variant_id] || variantData[item.id];
    const isMentik = Boolean(metadata) || item.handle === 'mentik-menthe-forte-36-chewing-gums';
    const variantOptions = item.options_with_values || [];
    const variantTitle = (item.variant_title || '').split(' / ');
    const format = variantOptions.find(option => option.name === 'Format')?.value || metadata?.format || variantTitle[0];
    const flavor = variantOptions.find(option => option.name === 'Saveur')?.value || metadata?.flavor || variantTitle[1] || '';
    const composition = Object.entries(item.properties || {}).filter(([name, value]) => /^Boîte [1-6]$/.test(name) && availableFlavors.includes(value)).sort(([first], [second]) => first.localeCompare(second, 'fr')).map(([, value]) => value);
    const boxFlavors = composition.length ? composition : flavor && flavor !== 'Mix au choix' ? Array(metadata?.boxes || 1).fill(flavor) : [];
    const flavorSummary = boxFlavors.length > 1 ? describeFlavors(boxFlavors) : boxFlavors[0] || flavor;
    const flavorImages = [...new Set(boxFlavors)].map(value => ({ flavor: value, image: catalog.find(variant => variant.flavor === value && variant.image)?.image })).filter(value => value.image);
    const variantParts = format.split(' — ');
    return {
      isMentik,
      title: isMentik && variantParts[0] ? variantParts[0] : item.product_title,
      detail: isMentik ? variantParts.slice(1).join(' — ') : item.variant_title || '',
      flavor,
      boxFlavors,
      flavorSummary,
      flavorImages,
      thumbnail: metadata?.image || item.image,
      flavorImage: Boolean(metadata?.image),
      boxes: metadata?.boxes,
      gums: metadata?.gums
    };
  }
  function renderSelection(cart) {
    if (!confidence) return;
    const selected = cart.items.map(item => ({ ...cartItemDetails(item), quantity: item.quantity })).filter(item => item.isMentik);
    confidence.hidden = !selected.length;
    document.querySelector('#cart-selection').innerHTML = selected.map(item => `<li><strong>${item.quantity} × ${escape(item.title)}</strong><span>${escape(item.flavorSummary || 'Saveur non précisée')}${item.quantity > 1 ? '<small>par pack</small>' : ''}</span></li>`).join('');
    const countsKnown = selected.every(item => Number.isFinite(item.boxes) && Number.isFinite(item.gums));
    const boxes = selected.reduce((total, item) => total + item.boxes * item.quantity, 0);
    const gums = selected.reduce((total, item) => total + item.gums * item.quantity, 0);
    const flavors = new Set(selected.flatMap(item => item.boxFlavors));
    document.querySelector('#cart-facts').innerHTML = countsKnown && selected.length ? `<span><strong>${boxes} ${boxes > 1 ? 'boîtes' : 'boîte'}</strong>dans votre panier</span><span><strong>${gums} gums</strong>au total</span><span><strong>${flavors.size} ${flavors.size > 1 ? 'saveurs' : 'saveur'}</strong>dans votre sélection</span>` : '';
  }
  function stopSessionTimer() {
    window.clearInterval(sessionInterval);
    sessionInterval = null;
  }
  function tickSessionTimer() {
    const remaining = Math.max(0, Math.ceil((sessionDeadline - Date.now()) / 1000));
    document.querySelector('#cart-session-time').textContent = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
    document.querySelector('#cart-session-progress').style.width = `${Math.min(100, remaining / 300 * 100)}%`;
    if (!remaining) {
      cartSession.hidden = true;
      stopSessionTimer();
    }
  }
  function updateSessionTimer() {
    if (!cartSession) return;
    stopSessionTimer();
    const hasItems = Boolean(currentCart?.item_count);
    cartSession.hidden = !hasItems;
    if (!hasItems) {
      if (currentCart) {
        sessionDeadline = 0;
        sessionOpening = false;
        try { sessionStorage.removeItem(sessionKey); } catch {}
      }
      return;
    }
    if (!sessionDeadline) {
      try { sessionDeadline = Number(sessionStorage.getItem(sessionKey)); } catch {}
    }
    if (!Number.isFinite(sessionDeadline) || sessionDeadline <= 0 || (sessionOpening && sessionDeadline <= Date.now())) {
      sessionDeadline = Date.now() + 5 * 60 * 1000;
      try { sessionStorage.setItem(sessionKey, String(sessionDeadline)); } catch {}
    }
    sessionOpening = false;
    tickSessionTimer();
    if (dialog.open && sessionDeadline > Date.now()) sessionInterval = window.setInterval(tickSessionTimer, 1000);
  }
  function showError(target, message) {
    if (!target) return;
    target.textContent = message;
    target.hidden = !message;
  }
  async function request(path, payload) {
    const response = await fetch(root + path, payload ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Le panier n’a pas pu être mis à jour. Réessayez.');
    return data;
  }
  function purchaseSelection() {
    const selected = options?.querySelector('input:checked');
    if (!selected) return null;
    const count = Number(selected.dataset.boxes) || 1;
    const boxFlavors = boxChoices ? Array.from(boxChoices.querySelectorAll('select')).map(input => input.value) : [];
    if (boxFlavors.length !== count || boxFlavors.some(flavor => !availableFlavors.includes(flavor))) return null;
    const flavor = new Set(boxFlavors).size > 1 ? 'Mix au choix' : boxFlavors[0];
    const variant = catalog.find(value => value.format === selected.dataset.format && value.flavor === flavor);
    if (!variant) return null;
    const properties = count > 1 ? Object.fromEntries(boxFlavors.map((value, index) => [`Boîte ${index + 1}`, value])) : {};
    return { ...variant, properties, boxFlavors };
  }
  function flavorImage(flavor) {
    return catalog.find(variant => variant.flavor === flavor && variant.image)?.image || '';
  }
  function updateProductImage(flavor) {
    const productImage = document.querySelector('#flavor-product-image');
    const image = flavorImage(flavor);
    if (productImage && image) {
      productImage.src = image;
      productImage.alt = `Mentik ${flavor} — boîte de 30 gums fermée et tenue ouverte dans une main`;
      const thumbnail = document.querySelector('[data-flavor-thumbnail]');
      if (thumbnail) thumbnail.src = image;
      document.querySelector('#story-gallery-track')?.dispatchEvent(new Event('mentik:flavor-preview'));
    }
  }
  function updateComposerSummary() {
    const boxFlavors = Array.from(boxChoices.querySelectorAll('select')).map(input => input.value);
    document.querySelector('#box-composer-summary').innerHTML = [...new Set(boxFlavors)].map(flavor => `<span data-flavor="${escape(flavor)}">${boxFlavors.filter(value => value === flavor).length} × ${escape(flavor)}</span>`).join('');
  }
  function updateComposer() {
    if (!boxComposer || !boxChoices) return;
    const selected = options?.querySelector('input:checked');
    const count = Number(selected?.dataset.boxes) || 1;
    const selectedFlavor = variantData[selected?.value]?.flavor;
    const baseFlavor = availableFlavors.includes(selectedFlavor) ? selectedFlavor : availableFlavors[0];
    boxComposer.hidden = false;
    boxComposer.classList.toggle('is-single', count === 1);
    document.querySelector('#box-composer-hint').textContent = count === 1 ? 'Votre boîte, votre saveur préférée.' : 'Une saveur par boîte. Identiques ou mélangées, sans supplément.';
    const boxFlavors = Array.from({ length: count }, (_, index) => configuredFlavors[index] || baseFlavor);
    boxFlavors.forEach((flavor, index) => { configuredFlavors[index] = flavor; });
    boxChoices.innerHTML = boxFlavors.map((flavor, index) => `<label class="box-flavor-choice" data-flavor="${escape(flavor)}"><span class="box-choice-heading"><span>Boîte ${index + 1}</span><small>30 gums</small></span><img class="box-flavor-image" src="${escape(flavorImage(flavor))}" alt="" width="64" height="82"><span class="box-flavor-control"><select aria-label="Saveur de la boîte ${index + 1}" name="properties[Boîte ${index + 1}]" data-box-index="${index}" required>${availableFlavors.map(value => `<option value="${escape(value)}"${value === flavor ? ' selected' : ''}>${escape(value)}</option>`).join('')}</select><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m4 6 4 4 4-4"/></svg></span></label>`).join('');
    updateComposerSummary();
    updateProductImage(boxFlavors[0]);
  }
  function updateSelection() {
    if (!addButton) return;
    const selected = purchaseSelection();
    const available = selected?.available === true;
    addButton.disabled = busy || !available;
    addButton.textContent = busy ? 'Mise à jour…' : available ? `Ajouter au panier — ${money(selected.price)}` : 'Cette composition est indisponible';
  }
  function setBusy(value) {
    busy = value;
    items.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('[data-change], [data-remove], [name="checkout"]').forEach(button => { button.disabled = value; });
    updateSelection();
  }
  function openCart() {
    if (dialog.open) return;
    sessionOpening = true;
    scrollPosition = window.scrollY;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.classList.add('cart-open');
    dialog.showModal();
    dialog.getBoundingClientRect();
    dialog.classList.add('is-visible');
    updateSessionTimer();
  }
  function closeCart() {
    if (!dialog.open || closing) return;
    closing = true;
    dialog.classList.remove('is-visible');
    window.setTimeout(() => { dialog.close(); closing = false; }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260);
  }
  dialog.addEventListener('close', () => {
    stopSessionTimer();
    document.body.classList.remove('cart-open');
    document.body.style.top = '';
    window.scrollTo({ top: scrollPosition, behavior: 'instant' });
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeCart(); });
  dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', closeCart));
  let backdropPressed = false;
  const outside = event => {
    const bounds = dialog.getBoundingClientRect();
    return event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
  };
  dialog.addEventListener('pointerdown', event => { backdropPressed = outside(event); });
  dialog.addEventListener('pointerup', event => { if (backdropPressed && outside(event)) closeCart(); backdropPressed = false; });
  function renderCart(cart) {
    currentCart = cart;
    currency = cart.currency || currency;
    document.querySelector('#cart-count').textContent = cart.item_count;
    document.querySelector('#drawer-count').textContent = cart.item_count;
    document.querySelector('#cart-total').textContent = money(cart.total_price);
    footer.hidden = cart.item_count === 0;
    if (reassurance) reassurance.hidden = cart.item_count === 0;
    renderSelection(cart);
    updateSessionTimer();
    if (discount) {
      discount.hidden = !cart.total_discount;
      document.querySelector('#cart-discount-total').textContent = `−${money(cart.total_discount || 0)}`;
    }
    if (!cart.item_count) {
      items.innerHTML = `<div class="cart-empty"><span class="wordmark" aria-hidden="true">mentik</span><h3>Votre première boîte<br>vous attend.</h3><p>Choisissez votre pack, puis composez vos saveurs sur la fiche produit.</p></div>`;
      return;
    }
    items.innerHTML = cart.items.map((item, index) => {
      const { isMentik, title, detail, flavor, flavorSummary, flavorImages, thumbnail, flavorImage } = cartItemDetails(item);
      const image = flavorImages.length > 1 ? `<div class="cart-mix-thumbnails" aria-label="Les saveurs de votre pack">${flavorImages.map(value => `<img src="${escape(value.image)}" alt="Boîte Mentik — ${escape(value.flavor)}" width="52" height="68">`).join('')}</div>` : thumbnail ? `<img class="cart-thumbnail${flavorImage ? ' cart-thumbnail-flavor' : ''}" src="${escape(thumbnail)}" alt="${escape(isMentik ? `Boîte Mentik${flavor ? ` — ${flavor}` : ''}` : item.product_title)}" width="104" height="136">` : '';
      const originalPrice = item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>` : '';
      return `<div class="cart-row">${image}<div class="cart-product"><div class="cart-product-heading"><div><strong>${escape(title)}</strong><span class="cart-detail">${escape(detail)}</span>${isMentik && flavorSummary ? `<span class="cart-flavor">${escape(flavorSummary)}</span>` : ''}</div><button class="cart-remove" data-remove data-index="${index}" aria-label="Supprimer ${escape(title)} ${escape(flavorSummary)}"><svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/></svg></button></div><div class="cart-line-actions"><div class="quantity"><button data-change="-1" data-index="${index}" aria-label="Retirer un lot ${escape(title)} ${escape(flavorSummary)}">−</button><span aria-label="Quantité">${item.quantity}</span><button data-change="1" data-index="${index}" aria-label="Ajouter un lot ${escape(title)} ${escape(flavorSummary)}">+</button></div><div class="cart-line-price">${originalPrice}<strong>${money(item.final_line_price)}</strong></div></div></div></div>`;
    }).join('');
  }
  document.querySelector('#open-cart').addEventListener('click', async event => {
    event.preventDefault();
    if (busy) { openCart(); return; }
    showError(cartError, '');
    items.textContent = 'Chargement de votre panier…';
    footer.hidden = true;
    if (reassurance) reassurance.hidden = true;
    if (confidence) confidence.hidden = true;
    openCart();
    setBusy(true);
    try { renderCart(await request('cart.js')); }
    catch { items.textContent = ''; showError(cartError, 'Impossible de charger le panier. Fermez-le et réessayez.'); }
    finally { setBusy(false); }
  });
  options?.addEventListener('change', () => { updateComposer(); updateSelection(); showError(productError, ''); });
  boxChoices?.addEventListener('change', event => {
    const input = event.target.closest('select[data-box-index]');
    if (!input) return;
    configuredFlavors[Number(input.dataset.boxIndex)] = input.value;
    const choice = input.closest('.box-flavor-choice');
    choice.dataset.flavor = input.value;
    choice.querySelector('img').src = flavorImage(input.value);
    updateComposerSummary();
    updateProductImage(input.value);
    updateSelection();
    showError(productError, '');
  });
  productForm?.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || addButton.disabled) return;
    const selected = purchaseSelection();
    if (!selected?.available) { showError(productError, 'Choisissez une saveur pour chaque boîte.'); return; }
    setBusy(true);
    showError(productError, '');
    showError(cartError, '');
    let added = false;
    try {
      await request('cart/add.js', { items: [{ id: selected.id, quantity: 1, properties: selected.properties }] });
      added = true;
      renderCart(await request('cart.js'));
      openCart();
      document.querySelector('#announcement').textContent = 'Votre sélection a été ajoutée au panier.';
    } catch (error) {
      showError(productError, added ? 'L’article a été ajouté. Ouvrez votre panier pour actualiser son contenu.' : error.message || 'Impossible de confirmer l’ajout. Vérifiez votre panier avant de réessayer.');
    } finally { setBusy(false); }
  });
  dialog.addEventListener('click', async event => {
    const discover = event.target.closest('[data-discover]');
    if (discover && document.querySelector('#produit')) {
      event.preventDefault();
      dialog.addEventListener('close', () => { document.querySelector('#produit').scrollIntoView(); }, { once: true });
      closeCart();
      return;
    }
    const button = event.target.closest('[data-change], [data-remove]');
    if (!button || busy || !currentCart) return;
    const index = Number(button.dataset.index);
    const item = currentCart.items[index];
    if (!item) return;
    const quantity = button.hasAttribute('data-remove') ? 0 : Math.max(0, item.quantity + Number(button.dataset.change));
    showError(cartError, '');
    setBusy(true);
    try {
      renderCart(await request('cart/change.js', { id: item.key, quantity }));
      document.querySelector('#announcement').textContent = 'Panier mis à jour.';
    } catch (error) {
      showError(cartError, error.message || 'Impossible de modifier la quantité.');
      try { renderCart(await request('cart.js')); } catch {}
    } finally {
      setBusy(false);
      const replacement = items.querySelector(`[data-index="${index}"][data-change="${button.dataset.change}"]`);
      (replacement || dialog.querySelector('[data-close]')).focus();
    }
  });
  options?.classList.add('has-flavor-selector');
  updateComposer();
  updateSelection();
  const storyTrack = document.querySelector('#story-gallery-track');
  if (storyTrack) {
    const storyGallery = storyTrack.closest('.product-story-gallery');
    const storyNav = storyGallery.querySelector('.story-gallery-nav');
    const storyButtons = Array.from(storyNav.querySelectorAll('[data-gallery-index]'));
    const storySlides = Array.from(storyTrack.querySelectorAll('.story-gallery-slide'));
    const storyCount = storyGallery.querySelector('#story-gallery-count');
    const storyTitle = storyGallery.querySelector('#story-gallery-title');
    const storyArrows = Array.from(storyGallery.querySelectorAll('[data-gallery-direction]'));
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let activeStory = 0;
    const updateStory = () => {
      if (!storyTrack.clientWidth) return;
      activeStory = Math.max(0, Math.min(storySlides.length - 1, Math.round(storyTrack.scrollLeft / storyTrack.clientWidth)));
      storyButtons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === activeStory)));
      storySlides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== activeStory)));
      storyCount.textContent = `${activeStory + 1} / ${storySlides.length}`;
      storyTitle.textContent = storySlides[activeStory].dataset.galleryLabel;
      storyArrows.forEach(button => { button.disabled = Number(button.dataset.galleryDirection) < 0 ? activeStory === 0 : activeStory === storySlides.length - 1; });
    };
    const showStory = (index, behavior = reducedMotion.matches ? 'instant' : 'smooth') => {
      const target = Math.max(0, Math.min(storySlides.length - 1, index));
      storyTrack.scrollTo({ left: target * storyTrack.clientWidth, behavior });
    };
    storyNav.hidden = false;
    storyGallery.querySelector('.story-gallery-controls').hidden = false;
    storyButtons.forEach((button, index) => button.addEventListener('click', () => showStory(index)));
    storyArrows.forEach(button => button.addEventListener('click', () => showStory(activeStory + Number(button.dataset.galleryDirection))));
    storyTrack.addEventListener('scroll', updateStory, { passive: true });
    storyTrack.addEventListener('mentik:flavor-preview', () => showStory(0, 'instant'));
    storyGallery.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const target = event.key === 'Home' ? 0 : event.key === 'End' ? storySlides.length - 1 : Math.max(0, Math.min(storySlides.length - 1, activeStory + (event.key === 'ArrowRight' ? 1 : -1)));
      showStory(target);
      if (storyNav.contains(event.target)) storyButtons[target].focus({ preventScroll: true });
    });
    let storyWidth = storyTrack.clientWidth;
    new ResizeObserver(() => {
      if (storyTrack.clientWidth === storyWidth) return;
      storyWidth = storyTrack.clientWidth;
      showStory(activeStory, 'instant');
    }).observe(storyTrack);
    updateStory();
  }
})();
